import { render, staticRenderFns } from "./code.vue?vue&type=template&id=c3604f50&scoped=true&"
import script from "./code.vue?vue&type=script&lang=js&"
export * from "./code.vue?vue&type=script&lang=js&"
import style0 from "./code.vue?vue&type=style&index=0&id=c3604f50&prod&lang=scss&scoped=true&"
import style1 from "./code.vue?vue&type=style&index=1&id=c3604f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3604f50",
  null
  
)

export default component.exports